// extracted by mini-css-extract-plugin
module.exports = {"accordion":"az_kUb","increaseMarginLeft":"az_lUb","qualtricsEmbeddedFeedback":"az_mUb","customerReviewsAccordion":"az_nUb","fromTheBrandTitle":"az_oUb"};